import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=42c2e324&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=42c2e324&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c2e324')) {
      api.createRecord('42c2e324', component.options)
    } else {
      api.reload('42c2e324', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=42c2e324&", function () {
      api.rerender('42c2e324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/WootWriter/Editor.vue"
export default component.exports